import { useLayoutEffect } from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { Navigation } from './Navigation';

/**
 * Shell for all main app routes: scrollable page content plus persistent bottom navigation.
 */
export const AppLayout = () => {
  const location = useLocation();

  let postSignInHome = false;
  try {
    postSignInHome = sessionStorage.getItem('rbm_post_sign_in_home') === '1';
  } catch {
    postSignInHome = false;
  }

  useLayoutEffect(() => {
    try {
      if (sessionStorage.getItem('rbm_post_sign_in_home') !== '1') return;
      if (location.pathname === '/') {
        sessionStorage.removeItem('rbm_post_sign_in_home');
      }
    } catch {
      /* ignore */
    }
  }, [location.pathname]);

  if (postSignInHome && location.pathname !== '/') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex flex-col min-h-dvh w-full max-w-full bg-app">
      <div className="flex-1 min-h-0 min-w-0 flex flex-col relative">
        <Outlet />
      </div>
      <Navigation />
    </div>
  );
};

export default AppLayout;
